import { Button } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { Icon, List, ListElement, SpinnerLegacy } from "../../../components";
import { ErrorMessage } from "../../../components/errorMessage/ErrorMessage";
import { NavigationBarMenu } from "../../../components/navigation/NavigationBar";
import { ORDER_RULE } from "../../../constants/routes";
import { useParamAsNumber } from "../../../hooks/useParamAsNumber";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useOrderRulesList } from "../../../hooks/api/v2/orderRules/useOrderRulesList";
import { formatCurrency, pluralize } from "@sellar-io/common";
import { OrderRulesDialogCreate } from "../orderRule/components/OrderRulesDialogCreate";

export function OrderRules(): ReactElement {
  const orderRulesId = useParamAsNumber(ORDER_RULE, "orderRulesId", false);
  const [newOrderRuleDialogActive, setNewOrderRuleDialogActive] =
    useState(false);

  const { data, isLoading, isError, error } = useOrderRulesList({});

  return (
    <>
      <NavigationBarMenu
        title={"Order Rules"}
        rightComponent={
          <Button
            size={"small"}
            onClick={() => setNewOrderRuleDialogActive(true)}
          >
            <Icon icon={"PLUS"} />
            New
          </Button>
        }
      />
      {isLoading ? (
        <SpinnerLegacy />
      ) : isError ? (
        <ErrorMessage>
          {apiV2AssertError(error)?.response?.data.message ??
            "Unknown error occurred"}
        </ErrorMessage>
      ) : (
        <div>
          <List className="mx-auto">
            {data?.pages[0]?.map((orderRules, i) => {
              const numberOfRules = orderRules.PriceTierOrderRules.length;

              return (
                <ListElement
                  promptText={"See details"}
                  key={i}
                  to={ORDER_RULE.href({ orderRulesId: orderRules.id })}
                  selected={orderRules.id === orderRulesId}
                >
                  <div className="flex flex-col gap-2">
                    <div>
                      <b>{orderRules.name}</b>
                    </div>
                    <div className="flex flex-col gap-0.5 text-zinc-500">
                      <span>
                        {formatCurrency(orderRules.minimumOrderPrice)} minimum
                        order size
                      </span>
                      <span>
                        {numberOfRules} container{" "}
                        {pluralize("rule", numberOfRules)}
                      </span>
                    </div>
                  </div>
                </ListElement>
              );
            })}
          </List>
        </div>
      )}
      <OrderRulesDialogCreate
        active={newOrderRuleDialogActive}
        onDismiss={() => setNewOrderRuleDialogActive(false)}
      />
    </>
  );
}
